<template>
  <div class="deck-container" oncontextmenu="return false;">
    <canvas
      id="deckgl"
      ref="canvas"
      style="background-color: rgb(54, 57, 62); width: 0"
    ></canvas>
    <canvas
      id="region_selection"
      width="7200px"
      height="4320px"
      style="
        position: absolute;
        border: 1px solid #ffffff;
        background: transparent;
        pointer-events: none;
      "
    ></canvas>
  </div>
</template>

<script>
import { Deck, OrthographicView, COORDINATE_SYSTEM } from "@deck.gl/core";
import { ScatterplotLayer, ArcLayer } from "@deck.gl/layers";
import { HeatmapLayer } from "@deck.gl/aggregation-layers";
import axios from 'axios';

export default {
  name: "deckgl",
  data() {
    return {
      deckgl: {},
      edges: [],
      nodes: [], // [[nodes_any_ini],[nodes_any_ini+1]...[nodes_any_fi]]
      cluster_dic: {},
      centre_escena: [0, 0, 0],
      vista_actual: {},
      nodesCalor: [],
      capa_calor: [],
      escala: 20,
      region_x: 0,
      region_y: 0,
      region_coord_x: 0,
      region_coord_y: 0,
      active_region_selection: false,
      any_base: 2010,
      nodesScopus: {},
      scopusVisibles: {},
      ids_nodes_cerca: [],
      min_growth_slope: undefined
    };
  },
  methods: {
    parsejacolor: function (colorRGB) {
      let r = parseInt(colorRGB.split("(")[1].split(")")[0].split(",")[0]);
      let g = parseInt(colorRGB.split("(")[1].split(")")[0].split(",")[1]);
      let b = parseInt(colorRGB.split("(")[1].split(")")[0].split(",")[2]);
      return [r, g, b];
    },
    min(a, b) {return a<b?a:b},
    getdata: async function () {
      console.log("10");
      // Obtenim els clústers i ordenem per ordre alfabètic del seu nom.
      this.$store.state.clusters = await this.carrega_clusters();
      this.$store.state.clusters.sort((a,b)=>{
        if (a['cluster'] < b['cluster']) return -1;
        if (a['cluster'] > b['cluster']) return 1;
        return 0;
      });
      this.cluster_dic = {}
      for (let i = 0; i < this.$store.state.clusters.length; i++) { this.$store.state.clusters[i]['ordered_id'] = i+1; }
      this.$store.state.clusters.forEach(a => this.cluster_dic[a['id']] = {cluster: a['cluster'], color: a['color']});

      let escala = this.escala;
      let minX = 0;
      let maxX = 0;
      let minY = 0;
      let maxY = 0;
      this.nodes = [];
      this.edges = [];
      this.$store.state.clusters_seleccionats=[];
      let store_nodes = this.$store.state.graf_actual.nodes;
      let store_edges = this.$store.state.graf_actual.edges;

      // nodes separats per anys
      this.any_base = parseInt(this.$store.getters.any_actual[0]);
      let any_final = parseInt(this.$store.getters.any_actual[1]);
      for (let i = 0; i <= any_final - this.any_base; i++)
        this.nodes.push([]);

      for (let i = 0; i < store_nodes.length; i++)
        if (store_nodes[i].disciplines == [null])
          store_nodes[i].disciplines = []
        
      console.log("10.1");
      for (let i = 0; i < store_nodes.length; i++) {
        let nodeaux = {
          id: store_nodes[i].id,
          color: this.parsejacolor(this.cluster_dic[store_nodes[i].cluster].color),
          position: [store_nodes[i].x * escala, store_nodes[i].y * escala, 0],
          nom: store_nodes[i].label,
          id_cluster: store_nodes[i].cluster.toString(),
          cluster: this.cluster_dic[store_nodes[i].cluster].cluster,
          any: parseInt(store_nodes[i].date.substring(0,4)),
          date: store_nodes[i].date,
          link: store_nodes[i].link,
          ind_authors: store_nodes[i].ind_authors,
          disciplines: store_nodes[i].disciplines,
        };
        
        let nodecalor=[store_nodes[i].x * escala,store_nodes[i].y *escala, parseFloat(store_nodes[i].growth)];
        if (this.min_growth_slope === undefined || store_nodes[i].growth < this.min_growth_slope) {
          this.min_growth_slope = store_nodes[i].growth;
        }
        this.nodesCalor.push(nodecalor);

        this.nodes[nodeaux.any-this.any_base].push(nodeaux);
        
        // No cal nodesOriginals, es decidirà el color per filtre a la layer, la llista de nodes no canvia

        if (nodeaux.position[0] > maxX) maxX = nodeaux.position[0];
        if (nodeaux.position[0] < minX) minX = nodeaux.position[0];
        if (nodeaux.position[1] > maxY) maxY = nodeaux.position[1];
        if (nodeaux.position[1] < minY) minY = nodeaux.position[1];
      }
      
      this.centre_escena = [(minX + maxX) / 2, (minY + maxY) / 2, 0];

      console.log("10.2");
      for (let j = 0; j < store_edges.length; j++) {
        let edgeaux = {
          origen: {
            id: store_edges[j].source,
            cluster: store_edges[j].cluster_origen.toString(),
            position: [store_edges[j].x_origen * escala, store_edges[j].y_origen * escala, 0],
            any: parseInt(store_edges[j].data_origen.substring(0,4)),
            color: this.parsejacolor(this.cluster_dic[store_edges[j].cluster_origen.toString()].color),
          },
          desti: {
            id: store_edges[j].target,
            cluster: store_edges[j].cluster_desti.toString(),
            position: [store_edges[j].x_desti* escala, store_edges[j].y_desti * escala, 0],
            any: parseInt(store_edges[j].data_desti.substring(0,4)),
            color: this.parsejacolor(this.cluster_dic[store_edges[j].cluster_desti.toString()].color),
          },
          color_visible: this.parsejacolor(this.cluster_dic[store_edges[j].cluster_origen.toString()].color),
        };
        this.edges.push(edgeaux);
      }
      console.log("11");

      // Inicialitzar estructures de control de scopus
      Object.keys(this.$store.getters.disciplines).forEach(disc => {
        this.nodesScopus[disc] = [];
        this.scopusVisibles[disc] = false;
      });
    },
    carrega_clusters: function() {
      let url=this.$store.getters.api_url+"get_muntanyes";
      return new Promise((resolve) => {
        this.$api.get(url)
          .then(function (response) {
            let llista_clusters_tmp = [];
            for(let key in response.data)
              llista_clusters_tmp.push({'id': key, 'cluster': response.data[key][0], 'color': response.data[key][1]});
            resolve(llista_clusters_tmp);
          })
          .catch(function (error) {
            // handle error
            console.log(error);
            this.$root.$emit("LoadingStage", 10, this.$t("Couldn't fetch clusters"), true);
            resolve();
          });
      });
    },
    get_color_disciplina: function(index_disciplina){
      let color = this.$store.getters.disciplines[index_disciplina];
      let rgb = color.substring(5, color.length-1).replace(/ /g, '').split(',');
      rgb[0]=parseInt(rgb[0])
      rgb[1]=parseInt(rgb[1])
      rgb[2]=parseInt(rgb[2])
      rgb[3]=parseInt(rgb[3])
      return rgb;
    },
  
    calculaScopus: async function(disciplina) { 
      let data = [];
      let rang_anys = this.$store.getters.anys_Seleccionats;
      let any_ini = parseInt(this.$store.getters.any_actual[0]);
      for(let i = rang_anys[0]-any_ini; i < rang_anys[1]-rang_anys[0]+1 && i < this.nodes.length; i++){
        for (let k = 0; k < this.nodes[i].length; k++) {
          if(this.nodes[i][k].disciplines.includes(disciplina)){
            data.push({position: this.nodes[i][k].position});  
          }
        }
      }
      this.nodesScopus[disciplina] = data;
    },

    enviaNode: async function(node){
      this.$store.dispatch("SeleccionaNode", node);
      this.$root.$emit("ActualitzaInfoNode");
    },
    enviaSeleccio: async function(cx_ini, cy_ini, cx_fin, cy_fin) {
      let
        MaxX = cx_ini > cx_fin ? cx_ini : cx_fin,
        MinX = cx_ini + cx_fin - MaxX,
        MaxY = cy_ini > cy_fin ? cy_ini : cy_fin,
        MinY = cy_ini + cy_fin - MaxY;
      let payload = {'maxX':MaxX, 'minX':MinX, 'maxY':MaxY, 'minY':MinY};
      console.log('Mx', MaxX*this.escala);
      console.log('mx', MinX*this.escala);
      console.log('My', MaxY*this.escala);
      console.log('my', MinY*this.escala);
      this.$store.dispatch("MostraZona", payload);
      this.$root.$emit("ActualitzaInfoZona");
    },
    resetGraph: function(){
      this.$store.dispatch('reset');
      this.ids_nodes_cerca = [];
      this.refreshdeckgl();
    },
    inicialitzadeckgl: async function () {
      this.$store.dispatch("Activa_loader");
      console.log("9");
      await this.getdata();
      this.vista_actual = {
        target: [this.centre_escena[0], this.centre_escena[1], 0],
        rotationX: 90,
        minZoom: 0.2,
        zoom: 0.8,
        maxZoom: 10.3
      }

      this.deckgl = new Deck({
        id: 'deckgl-overlay',
        width: '90%',
        height: '95%',
        canvas: this.$refs.canvas,
        views: [new OrthographicView()],
        initialViewState: this.vista_actual,
        controller: {
          dragRotate: false,
          doubleClickZoom: false,
          keyboard: {
            zoomSpeed: 1,
            moveSpeed: -50,
          }
        },
        effects: [],
        onClick: (_, event) => {
          if (event.rightButton) this.resetGraph();
        },
        onDragStart: (info, event) => {
          if (event.rightButton) this.startRegionSelection(info.x, info.y, info.coordinate[0]/this.escala, info.coordinate[1]/this.escala);
        },
        onDrag: (info, event) => {
          if (event.rightButton && this.active_region_selection) this.updateRegionSelection(info.x, info.y);
        },
        onDragEnd: (info, event) => {
          if (event.rightButton && this.active_region_selection) this.finishRegionSelection(info.coordinate[0]/this.escala, info.coordinate[1]/this.escala);
        },
        getCursor: ({isDragging, isHovering}) => (isDragging ? (this.active_region_selection ? 'crosshair' : 'grabbing') : (isHovering ? 'pointer' : 'grab')),
        getTooltip: ({ object }) =>
          object && {
            html: `<h4 style=float: left;>${object.nom}</h4><h4 style=float: left;>${this.$t("Cluster")}: ${object.cluster == 'undefined' ? this.$t('Non-clustered') : object.cluster } </h4><h5 style=float: left;>${this.$t("Year")}: ${object.any} </h5>`,
            style: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              fontSize: "0.7em",
              fontColor: "#FFF",
              maxWidth: "200px",
              maxHeight: "150px",
              position: "fixed",
              cursor: "default",
            },
          },
        layers: this.build_deckgl_layers()

      });
      console.log("12");
      this.$store.subscribe((mutation) => {
        if (  mutation.type === 'mostra_zona'
          ||  mutation.type === 'SeleccionaNode'
          ||  mutation.type === 'PintarHeatMap'
          ||  mutation.type === 'CanviOpacitat'
          ||  mutation.type === 'AmagaInfo'
          ||  mutation.type === 'Amaga_zona'
          ||  mutation.type === 'HideNodes'
        ) { this.refreshdeckgl(); }
        else if (mutation.type === 'actualitza_show_undef') {
          let coord = this.$store.state.coordenades_zona;
          this.enviaSeleccio(coord.maxX, coord.maxY, coord.minX, coord.minY);
        }
      });
      this.$store.subscribe(async (mutation) => {
        if (mutation.type === 'anysSeleccionats') {
          // Invalidar scopus
          Object.keys(this.$store.getters.disciplines).forEach(e => { 
            this.scopusVisibles[e] = false;
          });
          // Calcular només disciplines visibles 
          // És possible que es pugui fer amb un promise per no alentir el moviment del slider, però no sé molt bé com
          /*
          return new Promise(
            (resolve) => {
              this.$store.getters.disciplines_seleccionades.forEach(async (e) => {
                this.calculaScopus(e);
                this.scopusVisibles[e] = true;
              });
              this.refreshdeckgl();
              resolve('Recalculat disciplines');
            }
          );
          /*/
          await this.$store.getters.disciplines_seleccionades.forEach(async (e) => {
            this.calculaScopus(e);
            this.scopusVisibles[e] = true;
          });
          this.refreshdeckgl();
          //*/
        }
      });
      this.$store.subscribe(async (mutation) => {
        if (mutation.type === 'MarcarDisciplines') {
          let disciplines = Object.keys(this.$store.getters.disciplines);
          let disciplines_seleccionades = this.$store.getters.disciplines_seleccionades;
          for (let i = 0; i < disciplines.length; i++) {
            let disciplina = disciplines[i];  
            this.scopusVisibles[disciplina] = disciplines_seleccionades.includes(disciplina);
            if (this.scopusVisibles[disciplina]) {
              await this.calculaScopus(disciplina);
            }
          }
          this.refreshdeckgl();
        }
      });
      this.$store.dispatch("Desactiva_loader");
    },

    refreshdeckgl: function () {
      console.log("9-ref");      
      
      this.vista_actual=this.deckgl.viewState;      
      
      this.deckgl.setProps({
        canvas: this.$refs.canvas,
        views: [new OrthographicView()],
        initialViewState: this.vista_actual,
        controller: {
          dragRotate: false,
          doubleClickZoom: false,
          keyboard: {
            zoomSpeed: 1,
            moveSpeed: -50,
          }
        },
        width: '90%',
        height: '95%',
        layers: this.build_deckgl_layers()
      });
      
      console.log("12-ref");
    },

    build_deckgl_layers: function() {
      let capes_scopus = [];
      let disciplines = this.$store.getters.disciplines_seleccionades;
      for (let i = 0; i < disciplines.length; i++) {
        let disc = disciplines[i];
        capes_scopus.push( new HeatmapLayer({
          id: disc,
          data: this.nodesScopus[disc],
          visible: this.scopusVisibles[disc],
          aggregation: 'SUM',
          colorRange: [this.get_color_disciplina(disc)],
          getPosition: d => d.position,
          getWeight: 1,
          intensity: 1,
          radiusPixels: 75,
          threshold: 0.3,
        })); 
      }

      let first_year = this.llista_anys_seleccionats[0];
      let last_year  = this.llista_anys_seleccionats[1];

      // filtrar nodes seleccionats / no_seleccionats per cada any
      let nodes_seleccionats_clusters = [];
      let nodes_no_seleccionats_clusters = [];
      let nodes_seleccionats_undefined = [];
      let nodes_no_seleccionats_undefined = [];
      let nodes_clusters_relacionats = [];
      let nodes_cercats = [];
      for (let year = first_year; year <= last_year; year++) {
        let curr_layer_data = this.build_filtered_node_layers_year(year);
        nodes_seleccionats_clusters = nodes_seleccionats_clusters.concat(curr_layer_data[0]);
        nodes_seleccionats_undefined = nodes_seleccionats_undefined.concat(curr_layer_data[1]);
        nodes_no_seleccionats_clusters = nodes_no_seleccionats_clusters.concat(curr_layer_data[2]);
        nodes_no_seleccionats_undefined = nodes_no_seleccionats_undefined.concat(curr_layer_data[3]);
        nodes_clusters_relacionats = nodes_clusters_relacionats.concat(curr_layer_data[4]);
        nodes_cercats = nodes_cercats.concat(curr_layer_data[5]);
      }

      let line_color_clust_relacionats = nodes_clusters_relacionats.length == 0 ? [0,0,0] : this.parsejacolor(this.cluster_seleccionat_store['color']);

      // filtrar arestes visibles i amb color de nodes seleccionats.
      let selected_edges = []
      let non_selected_edges = []
      for (let i = 0; i < this.edges.length; i++) {
        let evaluated_edge_info = this.is_edge_selected(this.edges[i]);
        if (evaluated_edge_info.visible) {
          if (evaluated_edge_info.selected) {
            this.edges[i].color_visible = evaluated_edge_info.color;
            selected_edges.push(this.edges[i]);
          } else {
            non_selected_edges.push(this.edges[i]);
          }
        }
      }

      // rectangle de seleccio
      let seleccio_arestes = [0,0, 0,0, 0,0, 0,0]; // default, no hauria de ser visible si no display_zona.
      if (this.$store.getters.display_zona) {
        let seleccio = this.$store.state.coordenades_zona;
        seleccio_arestes = [
          [seleccio['minX']*this.escala, seleccio['minY']*this.escala],
          [seleccio['maxX']*this.escala, seleccio['minY']*this.escala],
          [seleccio['maxX']*this.escala, seleccio['maxY']*this.escala],
          [seleccio['minX']*this.escala, seleccio['maxY']*this.escala]
        ];
      }

      return [
        new HeatmapLayer({
          id: 'capa-calor',
          data: this.nodesCalor,
          aggregation: 'MEAN',
          visible: this.$store.getters.heat_map,
          colorRange: [[165,0,38], [215,48,39], [244,109,67], [253,174,97], [254,224,144], [255,255,191], [224,243,248], [171,217,233],[116,173,209],[69,117,180],[49,54,149]].reverse(),
          getPosition: d => [d[0],d[1]],
          getWeight: d => d[2]-this.min_growth_slope,
          intensity: .95,
          threshold: 1,
          radiusPixels: 15,
          debounceTimeout: 300,
        }),
        capes_scopus,
        new ArcLayer({
          id: "non_selected_edges",
          coordinateSystem: COORDINATE_SYSTEM.CARTESIAN,
          opacity: this.opacitat_arestes * 0.2,
          pickable: false,
          getWidth: 0.5,
          getTilt: -90,
          getHeight: 0.4,
          greatCircle: true,
          data: non_selected_edges,
          visible: !this.$store.getters.amagar_nodes && this.opacitat_arestes > 0,
          getSourcePosition: (d) => d.origen.position,
          getTargetPosition: (d) => d.desti.position,
          getColor: [100,100,100],
          getSourceColor: [100,100,100],
          getTargetColor: [100,100,100]
        }),
        new ScatterplotLayer({
          id: 'non_selected_nodes_undefined',
          data: nodes_no_seleccionats_undefined,
          pickable: true,
          opacity: 0.6,
          stroked: true,
          filled: true,
          radiusScale: 3,
          radiusMinPixels: 4,
          radiusMaxPixels: 4,
          lineWidthMinPixels: 1,
          lineWidthMaxPixels: 1,
          visible: !this.$store.getters.amagar_nodes,
          getPosition: d => d.position,
          getFillColor: [120,120,120],
          getLineColor: [30, 30, 30],
          onClick: (info, event) => this.handle_node_click(info.object, event.srcEvent.ctrlKey),
        }),
        new ScatterplotLayer({
          id: 'non_selected_nodes_clusters',
          data: nodes_no_seleccionats_clusters,
          pickable: true,
          opacity: 0.6,
          stroked: true,
          filled: true,
          radiusScale: 3,
          radiusMinPixels: 4,
          radiusMaxPixels: 4,
          lineWidthMinPixels: 1,
          lineWidthMaxPixels: 1,
          visible: !this.$store.getters.amagar_nodes,
          getPosition: d => d.position,
          getFillColor: [80, 80, 80],
          getLineColor: [30, 30, 30],
          onClick: (info, event) => this.handle_node_click(info.object, event.srcEvent.ctrlKey),
        }),
        new ArcLayer({
          id: "selected_edges",
          coordinateSystem: COORDINATE_SYSTEM.CARTESIAN,
          opacity: this.opacitat_arestes,
          pickable: false,
          getWidth: 0.5,
          getTilt: -90,
          getHeight: 0.4,
          greatCircle: true,
          data: selected_edges,
          visible: !this.$store.getters.amagar_nodes && this.opacitat_arestes > 0,
          getSourcePosition: (d) => d.origen.position,
          getTargetPosition: (d) => d.desti.position,
          getColor: (d) => d.color_visible,
          getSourceColor: (d) => d.color_visible,
          getTargetColor: (d) => d.color_visible
        }),
        new ScatterplotLayer({
          id: 'nodes_clusters_relacionats',
          data: nodes_clusters_relacionats,
          pickable: true,
          opacity: 1,
          stroked: true,
          filled: true,
          radiusScale: 3,
          radiusMinPixels: 4,
          radiusMaxPixels: 4,
          lineWidthMinPixels: 1,
          lineWidthMaxPixels: 1,
          visible: !this.$store.getters.amagar_nodes && this.$store.getters.show_releated_clusters,
          getPosition: d => d.position,
          getFillColor: c => c.color,
          getLineColor: line_color_clust_relacionats,
          onClick: (info, event) => this.handle_node_click(info.object, event.srcEvent.ctrlKey),
        }),
        new ScatterplotLayer({
          id: 'selected_nodes_undefined',
          data: nodes_seleccionats_undefined,
          pickable: true,
          opacity: 1,
          stroked: true,
          filled: true,
          radiusScale: 3,
          radiusMinPixels: 4,
          radiusMaxPixels: 4,
          lineWidthMinPixels: 1,
          lineWidthMaxPixels: 1,
          visible: !this.$store.getters.amagar_nodes,
          getPosition: d => d.position,
          getFillColor: c => c.color,
          getLineColor:[0, 0, 0],
          onClick: (info, event) => this.handle_node_click(info.object, event.srcEvent.ctrlKey),
        }),
        new ScatterplotLayer({
          id: 'selected_nodes_clusters',
          data: nodes_seleccionats_clusters,
          pickable: true,
          opacity: 1,
          stroked: true,
          filled: true,
          radiusScale: 3,
          radiusMinPixels: 4,
          radiusMaxPixels: 4,
          lineWidthMinPixels: 1,
          lineWidthMaxPixels: 1,
          visible: !this.$store.getters.amagar_nodes,
          getPosition: d => d.position,
          getFillColor: c => c.color,
          getLineColor:[0, 0, 0],
          onClick: (info, event) => this.handle_node_click(info.object, event.srcEvent.ctrlKey),
        }),
        new ScatterplotLayer({
          id: 'resultats_cerca',
          data: nodes_cercats,
          pickable: true,
          opacity: 1,
          stroked: true,
          filled: true,
          radiusScale: 3,
          radiusMinPixels: 5,
          radiusMaxPixels: 5,
          lineWidthMinPixels: 3,
          lineWidthMaxPixels: 3,
          visible: this.ids_nodes_cerca.length > 0 && !this.$store.getters.amagar_nodes,
          getPosition: d => d.position,
          getFillColor: c => c.color,
          getLineColor: [255, 255, 255],
          onClick: (info, event) => this.handle_node_click(info.object, event.srcEvent.ctrlKey),
        }),
        new ArcLayer({
          id: "seleccio_mantinguda",
          visible: this.$store.getters.display_zona && !this.$store.getters.amagar_nodes,
          coordinateSystem: COORDINATE_SYSTEM.CARTESIAN,
          pickable: false,
          opacity: 1,
          getWidth: 1,
          getTilt: -90,
          getHeight: 0,
          greatCircle: false,
          data: [0,1,2,3],
          getSourcePosition: (d) => seleccio_arestes[d],
          getTargetPosition: (d) => seleccio_arestes[(d+1)%4],
          getSourceColor: [255,255,255],
          getTargetColor: [255,255,255],
        }),

      ]
    },

    build_filtered_node_layers_year: function(year) {
      // per a l'any demanat, separa nodes en seleccionats/no-seleccionats
      // i per cadascuna, en undefined o pertanyents a clusters
      // si el node ha estat cercat, el marca com a tal
      // retorna les 5 llistes de nodes corresponents
      let year_idx = year - this.any_base;
      let nodes_seleccionats_cluster = [];
      let nodes_seleccionats_undefined = [];
      let nodes_no_seleccionats_cluster = [];
      let nodes_no_seleccionats_undefined = [];
      let nodes_clusters_relacionats = []
      let nodes_cercats = []

      for (let i = 0; i < this.nodes[year_idx].length; i++){
        let node = this.nodes[year_idx][i]
        if (this.ids_nodes_cerca.includes(node.id)) {
          nodes_cercats.push(node);
        }  else if (this.is_node_selected(node)){
          if (node.cluster === 'undefined') { nodes_seleccionats_undefined.push(node); } 
          else { nodes_seleccionats_cluster.push(node); }
        } else if (this.$store.getters.show_releated_clusters && this.cluster_seleccionat_store !== undefined && this.cluster_seleccionat_store['cluster'] !== 'undefined' &&
            this.$store.getters.related_clusters_dict[this.cluster_seleccionat_store['id']].some((e) => e[0] == node.id_cluster)) {
          nodes_clusters_relacionats.push(node);
        } else {
          if (node.cluster === 'undefined') { nodes_no_seleccionats_undefined.push(node); } 
          else { nodes_no_seleccionats_cluster.push(node); }
        }
      }

      return [nodes_seleccionats_cluster, nodes_seleccionats_undefined, nodes_no_seleccionats_cluster, nodes_no_seleccionats_undefined, nodes_clusters_relacionats, nodes_cercats]
    },

    is_node_selected: function(node) {
      // OJO no té en compte els anys, aquests es tenen en compte a la visibilitat de les layers

      // Node és el seleccionat
      if (this.$store.getters.node_Seleccionat != undefined && this.$store.getters.node_Seleccionat.id == node.id) return true;
      // Node pertany a un clúster seleccionat
      if (this.$store.getters.clusters_seleccionats.includes(node.id_cluster)) return true;
      // Node pertany a una regió seleccionada i activament mostrada
      let coord = this.$store.state.coordenades_zona;
      if (this.$store.getters.display_zona && 
        coord['minX']*this.escala <= node.position[0] && node.position[0] <= coord['maxX']*this.escala &&
        coord['minY']*this.escala <= node.position[1] && node.position[1] <= coord['maxY']*this.escala
      ) {
        if (this.$store.getters.zona_only_undef && this.cluster_dic[node.id_cluster]['cluster'] != 'undefined')
          return false;
        return true;
      }
      // No hi ha res seleccionat
      if (this.$store.getters.node_Seleccionat == undefined && this.$store.getters.clusters_seleccionats.length == 0 && !this.$store.getters.display_zona)
        return true;
      // Node no seleccionat
      return false;
    },
    is_edge_selected: function(edge) {
      // retorna seleccionada: color node prioritari     visible, seleccionada, [cr,cg,cb]
      //         no seleccionada: color gris             visible, no-seleccionada
      //         un dels nodes no visible: llista buida  no-visible

      // Primer mirem si algun dels dos nodes no és visible per rang d'anys.
      let any_ini = this.llista_anys_seleccionats[0];
      let any_fi  = this.llista_anys_seleccionats[1];
      if (edge.origen.any < any_ini || any_fi < edge.origen.any ||
          edge.desti.any  < any_ini || any_fi < edge.desti.any) return {visible: false, selected: undefined, color: undefined};

      let origen_seleccionat = this.is_node_selected({
        id: edge.origen.id,
        id_cluster: edge.origen.cluster,
        position: edge.origen.position
      });
      let desti_seleccionat = this.is_node_selected({
        id: edge.desti.id,
        id_cluster: edge.desti.cluster,
        position: edge.desti.position
      });

      // Origen té prioritat en cas d'empat (té sentit perquè els ordenem per actualitat de l'any)
      if (origen_seleccionat) return { visible: true, selected: true,  color: edge.origen.color };
      if (desti_seleccionat)  return { visible: true, selected: true,  color: edge.desti.color  };
      return { visible: true, selected: false, color: undefined }; // Aresta no seleccionada
    },
    handle_node_click: function (node, isCtrlCPressed) {
      if (isCtrlCPressed) { 
        let selected_clust = this.$store.getters.clusters_seleccionats.filter((c) => c !== node.id_cluster);
        selected_clust.push(node.id_cluster);
        this.$store.dispatch("MarcarClusters", selected_clust);
        this.$root.$emit("ActualitzaInfoCluster");
      } else { 
        this.enviaNode(node); 
      }
    },
    smooth_greyscale: (color, objective, factor) => {
      let mean = (color[0] + color[1] + color[2])/3;
      let gray = mean + factor*(objective-mean);
      return [gray, gray, gray];
    },
    /*smooth_color: (color, objective, factor) => {
      let mean = (color[0] + color[1] + color[2])/3;
      let displace = factor*(objective-mean);
      return [color[0]+displace, color[1]+displace, color[2]+displace];
    },*/
    deckReload() {
      //this.deckDestroy();
      this.$root.$emit("LoadingStage", 0, "", false);
      console.log('2')
      const url = this.$store.getters.api_url + '/create_graph';
      console.log('3')
      axios({
        method: 'get',
        url: url,
        params: {'model': this.$store.getters.any_actual.join('-')},
        responseType: 'json',
        onDownloadProgress: (progressEvent) => {
          let percentCompleted = Math.round((progressEvent.loaded * 10) / progressEvent.total);
          this.$root.$emit("LoadingStage", percentCompleted, "", false);
        }
      }).then((graph_response) => {
        this.$store.dispatch("loadGraph", graph_response.data);
        console.log("8");
        this.inicialitzadeckgl().then(() => {
          console.log("13");
          this.$root.$emit("LoadingStage", 10, "", false); // No es veurà
        });
      }).catch(
        () => { this.$root.$emit("LoadingStage", 10, this.$t("Couldn't fetch graph"), true); }
      );
    },
    deckDestroy() { // ns si és necessari
      this.vista_actual=this.deckgl.viewState;
    },
    startRegionSelection(x,y,cx,cy) {
      this.region_x = x;
      this.region_y = y;
      this.region_coord_x = cx;
      this.region_coord_y = cy;
      this.active_region_selection = true;  
    },
    updateRegionSelection(x,y) {
      let region_w = x - this.region_x
      let region_h = y - this.region_y
      let canvas = document.getElementById("region_selection");
      let ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = 'rgba(200,200,200,.25)';
      ctx.fillRect(this.region_x, this.region_y, region_w, region_h);
      ctx.strokeStyle = 'white';
      ctx.lineWidth = '2';
      ctx.strokeRect(this.region_x, this.region_y, region_w, region_h);
    },
    finishRegionSelection(cx,cy) {
      this.region_x = 0;
      this.region_y = 0;
      this.active_region_selection = false;
      let canvas = document.getElementById("region_selection");
      let ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.enviaSeleccio(this.region_coord_x, this.region_coord_y, cx, cy);
      console.log("Should show info for nodes inside rect:: ix: " + this.region_coord_x + ", iy: " + this.region_coord_y + ", fx: " + cx + ", fy: " + cy);
    }
  },
  mounted() {
    console.log("1");
    // if user chooses another model
    this.$store.watch((state) => state.any_actual, this.deckReload);
    // event listeners
    this.$root.$on('SearchSelectNode', (id_node) => {
      let selected_node;
      for (let i = 0; i < this.nodes.length; i++) {
        selected_node = this.nodes[i].find(node => node.id == id_node);
        if (selected_node != undefined) break;
      }
      if (selected_node != undefined)
        this.enviaNode(selected_node);
    });
    this.$root.$on('SearchResultsIds', (searched_nodes) => {
      let needsUpdate = this.ids_nodes_cerca != searched_nodes;
      this.ids_nodes_cerca = searched_nodes;
      if (needsUpdate) {
        this.refreshdeckgl();
      }
    });
    this.$root.$on('UpdateRelatedClusters', () => {
      this.refreshdeckgl();
    });
    this.$root.$on('ClusterInfoActualitzat', () => {
      this.refreshdeckgl();
    });
  },
  beforeDestroy() {
    this.deckDestroy();
    // event listeners
    this.$root.$off('ActualitzaSeleccioZona');
    this.$root.$off('SearchSelectNode');
    this.$root.$off('UpdateRelatedClusters');
    this.$root.$off('ClusterInfoActualitzat');
  },
  computed: {
    llista_anys_seleccionats() { return this.$store.getters.anys_Seleccionats; },
    llista_scopus_marcats() { return this.$store.getters.disciplines_seleccionades; },
    opacitat_arestes() { return this.$store.getters.opacitat_arestes; },
    cluster_seleccionat_store() { return this.$store.getters.clusters.find((e) => e['id'] === this.$store.getters.cluster_marcat); },
  },
};
</script>

<style>
body {
  margin: 0;
  /*display: inline;*/
}
</style>
